import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { environment } from 'environments/environment';

export class LogMissingTranslationHandler implements MissingTranslationHandler {
  private missingKey = new Set<string>();
  handle(params: MissingTranslationHandlerParams) {
    const isaRealKey = params.key.match(/(\w+.*\.\w+.*)+/g) && !params.key.match(/\s+/g) && params.key.match(/[A-Za-z]+/g);
    if (isaRealKey) {
      if (!environment.production && !this.missingKey.has(params.key)) {
        console.error('Missing translation key', params.key);
      }
      this.missingKey.add(params.key);
    }
    return params.key;
  }
}
